export default __webpack_public_path__ + "static/media/q18_03.47ac4700.png";